import * as React from 'react'
import {FC, useEffect, useRef} from 'react'
import {isFunction} from 'lodash'

///////////////////////////////////////////////////////////////////////////////

export type FormPartProps = {
  className?: string
  onSubmit?: () => void
}

///////////////////////////////////////////////////////////////////////////////

export const FormPart: FC<FormPartProps> = (props) => {
  const {children, className, onSubmit} = props
  const ref = useRef<HTMLDivElement>()

  useEffect(() => {
    const cont = ref.current
    const onKeydown = (e) => {
      const keyCode = e.which || e.keyCode
      const isEnter = keyCode === 13
      const hasHandler = isFunction(onSubmit)
      const isTargetInputText =
        e.target.tagName === 'INPUT' && e.target.type === 'text'

      if (isEnter && hasHandler && isTargetInputText) {
        e.preventDefault()
        e.stopPropagation()
        onSubmit()
      }
    }

    cont?.addEventListener('keydown', onKeydown)

    return () => cont?.removeEventListener('keydown', onKeydown)
  }, [])

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  )
}
